<template>
  <div>
    <!-- 날짜 -->
    <div class="absolute top-0 flex items-center gap-4" :class="[!isPrint && 'py-6']" style="left: calc(180px + 2rem)">
      <div class="flex items-center justify-center gap-3">
        <p v-if="isPrint" class="print-input">{{ form.headerYear | moment("YYYY") }}</p>
        <input v-else type="number" :readonly="board.readonly || isPostId" min="1800" max="9999" v-model="form.headerYear" style="width: 100px" />
        년
        <p v-if="isPrint" class="print-input">{{ form.headerMonth | moment("MM") }}</p>
        <input v-else type="number" :readonly="board.readonly || isPostId" min="1" max="12" v-model="form.headerMonth" style="width: 100px" @input="formatMonth"/>
        월
      </div>
    </div>

    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :options="[{ type: 'alert', label: '알림 대상자 선택' }]" />

    <!-- MSDS -->
    <msds-module :readonly="board.readonly" v-model="form.msds" :is-print="isPrint" />

    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" />
  </div>
</template>

<script>

import FieldSelectModule from '@/views/modules/FieldSelectModule.vue'
import FileUploadModule from '@/views/modules/FileUploadModule.vue'
import MsdsModule from '@/views/boards/single-page/447/MsdsModule.vue'
import moment from "moment";

export default {
  components: {
    MsdsModule,
    FileUploadModule,
    FieldSelectModule
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    "board": {
      immediate: true,
      deep: true,
      handler (/*value*/) {}
    },
    "value": {
      important: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }
      }
    },
    "form": {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    },
    'form.headerYear' : {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.headerDate = `${this.form.headerYear}-${this.form.headerMonth}-01`
        this.form.headerDateString = `${this.form.headerYear}년 ${this.form.headerMonth}월`
      }
    },
    'form.headerMonth' : {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.headerDate = `${this.form.headerYear}-${this.form.headerMonth}-01`
        this.form.headerDateString =  `${this.form.headerYear}년 ${this.form.headerMonth}월`
      }
    },
  },
  computed: {
    projectInfo () {
      return this.$store.state.project.projectInfo
    },
    isPostId() {
      return !!this.$route.params.postId;
    },
  },
  data () {
    return {
      form: {
        stdInfo: {},
        msds: [],
        fileList: [],

        headerYear: moment(new Date()).format("YYYY"),
        headerMonth: moment(new Date()).format("MM"),
        headerDate: '',
        headerDateString: '',
      },
    }
  },
  methods: {
    formatMonth() {
      this.form.headerMonth = String(this.form.headerMonth).padStart(2, '0');
    }
  }
}
</script>

<style scoped lang="scss">
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

input[type="number"] {
  height: 40px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 0.7rem !important;
  transition: all 0.3s ease;

  &:focus {
    border: 1px solid rgba(var(--vs-primary), 1) !important;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
  }
}
</style>
